import { Component, Inject, OnInit } from '@angular/core';
import { ColDef, GridApi } from 'ag-grid-community';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DateTimeEditor } from './datetime-editor/datetime-editor.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from '../../constant/common.constant';
import { Constants } from 'src/app/constants';
import { DateTime } from 'luxon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-border-crossing',
    templateUrl: './border-crossing.component.html',
    styleUrls: ['./border-crossing.component.scss'],
    standalone: false // NOSONAR
})
export class BorderCrossingComponent implements OnInit {
  gridApi: any;
  defaultColDef: ColDef;
  columnDef: ColDef[];
  rowClassRules: any;
  icons: any;
  context: any;
  data: any;
  rowHeight: 30;
  originalGridData: any[];
  displayRowData: any[] = [];
  successMessage: string;
  errorMessage: string;
  route: string;
  unload: string;
  isDSTChecked: boolean = false;
  currentTimeZone = 'EST';
  timeZoneList: any[] = [];
  selectedTimeZone: string;
  date_frmt = 'MM/dd/yyyy HH:mm'

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    public dialogRef: MatDialogRef<BorderCrossingComponent>,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    private  readonly constants: Constants,
     private  readonly dashboardService : DashboardService
  ) {
    this.context = {
      componentParent: this,
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',   // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',      // NOSONAR
    };
    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,
      autoHeight: true,
      filter: false,
      floatingFilter: false,
    };
    this.getColDefs();
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
  }

  getColDefs(): void {
    this.columnDef = [
      {
        headerName: 'BORDER CROSSING NAME',
        field: 'borderCrossingName',
        maxWidth: 150,
      },
      {
        headerName: 'PLANNED ARRIVAL',
        field: 'plannedArrivalDate',
        maxWidth: 150,
      },
      {
        headerName: 'ACTUAL ARRIVAL',
        field: 'actualArrivalDate',
        cellStyle: { cursor: 'pointer' },
        editable: true,
        cellEditorParams: {
          currentTimeZone: this.currentTimeZone,
        },
        cellEditor: DateTimeEditor,
        maxWidth: 300,
      },
      {
        headerName: 'PLANNED DEPARTURE',
        field: 'plannedDepartureDate',
        maxWidth: 150,
      },
      {
        headerName: 'ACTUAL DEPARTURE',
        field: 'actualDepartureDate',
        cellStyle: { cursor: 'pointer' },
        editable: true,
        cellEditorParams: {
          currentTimeZone: this.currentTimeZone,
        },
        cellEditor: DateTimeEditor,
        maxWidth: 300,
      },
    ];
  }

  ngOnInit(): void {
    this.data = this.dataStore;
    this.route = this.data.mainRoute;
    this.unload = this.data.unload;
    this.isDSTChecked = this.data.isDST;
    this.selectedTimeZone = this.data.timeZone;
    this.timeZoneList = [
      { description: 'Eastern', code: 'E' },
      { description: 'Central', code: 'C' },
      { description: 'Mountain', code: 'M' },
      { description: 'Pacific', code: 'P' },
    ];
    this.borderCrossing();
  }

  borderCrossing() {
    this.dashboardService
      .borderCrossing(this.data.routeId)
      .subscribe((res: any) => {
        this.currentTimeZone = 'EST';
        this.displayRowData = res.map((item: any) => {
          return {
            ...item,
            actualArrivalDate: this.dateFormatter(item.actualArrivalDate),
            actualDepartureDate: this.dateFormatter(item.actualDepartureDate),
            plannedArrivalDate: this.dateFormatter(item.plannedArrivalDate),
            plannedDepartureDate: this.dateFormatter(item.plannedDepartureDate),
          };
        });
        let requiredTz = this.selectedTimeZone + 'ST';
        if (this.isDSTChecked) {
          requiredTz = requiredTz.replace('S', 'D');
        }
        if (requiredTz != 'EST') {  // NOSONAR
          this.convertTimeZone(requiredTz);
        } else {
          this.originalGridData = JSON.parse(
            JSON.stringify(this.displayRowData)
          );
        }
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      });
  }

  dateFormatter(res) {
    return res
      ? DateTime.fromFormat(res, 'MM-dd-yyyy HH:mm:ss', {
          zone: this.constants.timeZones[this.currentTimeZone],
          setZone: true,
        }).toFormat(this.date_frmt) + ` (${this.currentTimeZone})`
      : null;
  }

  DSTCheck(event: any) {
    this.isDSTChecked = event.target.checked;
    let requiredTz = this.selectedTimeZone + 'ST';
    if (this.isDSTChecked) {
      requiredTz = requiredTz.replace('S', 'D');
    }
    this.getConvertedTimeZone(requiredTz);
  }

  onTimeZoneChange(event) {
    this.selectedTimeZone = event.value;
    let requiredTz = this.selectedTimeZone + 'ST';
    if (this.isDSTChecked) {
      requiredTz = requiredTz.replace('S', 'D');
    }
    this.getConvertedTimeZone(requiredTz);
  }

  convertTimeZone(neededTz) {
    this.displayRowData = this.displayRowData.map(
      (item: any, _index: number) => {
        return {
          ...item,
          actualArrivalDate: this.dateTzConverter(
            item.actualArrivalDate,
            neededTz
          ),
          actualDepartureDate: this.dateTzConverter(
            item.actualDepartureDate,
            neededTz
          ),
          plannedArrivalDate: this.dateTzConverter(
            item.plannedArrivalDate,
            neededTz
          ),
          plannedDepartureDate: this.dateTzConverter(
            item.plannedDepartureDate,
            neededTz
          ),
        };
      }
    );
    this.currentTimeZone = neededTz;
    this.getColDefs();
    this.gridApi.setColumnDefs(this.columnDef);
    this.gridApi.applyTransaction({ add: this.displayRowData }); 
    if (this.originalGridData) {
      this.originalGridData = this.originalGridData.map(
        (item: any, _index: number) => {
          return {
            ...item,
            actualArrivalDate: this.dateTzConverter(
              item.actualArrivalDate,
              neededTz
            ),
            actualDepartureDate: this.dateTzConverter(
              item.actualDepartureDate,
              neededTz
            ),
            plannedArrivalDate: this.dateTzConverter(
              item.plannedArrivalDate,
              neededTz
            ),
            plannedDepartureDate: this.dateTzConverter(
              item.plannedDepartureDate,
              neededTz
            ),
          };
        }
      );
    } else {
      this.originalGridData = JSON.parse(JSON.stringify(this.displayRowData));
    }
    this.ngxUiLoaderService.stop(CommonConstant.loader);
    this.gridApi?.redrawRows();
  }

  getConvertedTimeZone(neededTz) {
    this.successMessage = null;
    this.errorMessage = null;
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const upn = fgaDetails?.user?.userPrincipalName;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.dashboardService.getDashboardload(upn)?.subscribe(
      (_result) => {
        this.convertTimeZone(neededTz);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      (_error) => {
        this.convertTimeZone(neededTz);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      }
    );
  }

  dateTzConverter(date: string, neededTz: string) {
    if (date == undefined || date == null) {    // NOSONAR
      return null;
    }
    const test = DateTime.fromFormat(
      date.substring(0, 16),
      this.date_frmt,
      { zone: this.constants.timeZones[this.currentTimeZone], setZone: true }
    );
    return (
      test.setZone(this.constants.timeZones[neededTz]).toFormat(this.date_frmt) +
      ` (${neededTz})`
    );
  }

  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  reset(): void {
    this.displayRowData = JSON.parse(JSON.stringify(this.originalGridData));
  }

  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  saveClick() {
    this.successMessage = null;
    this.errorMessage = null;
    const toyotaGUID = localStorage.getItem('toyotaGUID');
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const changedValues = this.displayRowData.filter((value) => {
      return !this.borderCrossingEquals(
        value,
        this.originalGridData.find(
          (val) => val.borderCrossingId == value.borderCrossingId  // NOSONAR
        )
      );
    });
    console.info('changed....', changedValues);
    // backend calls on success show success msg
    const changedBorders = [];
    for (const chv of changedValues) {
      const payload = {
        actualArrivalDate: this.payloadDateConverter(chv.actualArrivalDate),
        actualDepartureDate: this.payloadDateConverter(chv.actualDepartureDate),
        borderCrossingId: chv.borderCrossingId,
      };
      changedBorders.push(payload);
    }
    this.dashboardService
      .saveBorderCrossing(changedBorders, toyotaGUID)
      .subscribe(
        (response: any) => {
          changedBorders.pop();
          this.borderCrossing();
          this.successMessage = response;
        },
        (error) => {
          console.info(error);
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, 5000);
        }
      );
  }

  payloadDateConverter(input: string): string {
    if (input == null) {  // NOSONAR
      return null;
    }
    return DateTime.fromFormat(input.substring(0, 16), this.date_frmt, {
      zone: this.constants.timeZones[this.currentTimeZone],
      setZone: true,
    })
      .setZone(this.constants.timeZones['EST'])
      .toFormat('MM-dd-yyyy HH:mm:ss');
  }

  borderCrossingEquals(
    object1: {
      actualArrivalDate: string;
      actualDepartureDate: string;
      borderCrossingId: number;
      borderCrossingName: string;
      plannedArrivalDate: string;
      plannedDepartureDate: string;
      routeId: number;
      seq: number;
      updatedBy: string;
      updatedOn: string;
    },
    object2: {
      actualArrivalDate: string;
      actualDepartureDate: string;
      borderCrossingId: number;
      borderCrossingName: string;
      plannedArrivalDate: string;
      plannedDepartureDate: string;
      routeId: number;
      seq: number;
      updatedBy: string;
      updatedOn: string;
    }
  ): boolean {
    if ( object1.actualArrivalDate != object2.actualArrivalDate || object1.actualDepartureDate != object2.actualDepartureDate ) { // NOSONAR
      return false;
    }
    return true;
  }
}
